import { render, staticRenderFns } from "./uiList.vue?vue&type=template&id=31831024&scoped=true"
import script from "./uiList.vue?vue&type=script&lang=js"
export * from "./uiList.vue?vue&type=script&lang=js"
import style0 from "./uiList.vue?vue&type=style&index=0&id=31831024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31831024",
  null
  
)

export default component.exports